"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _S3Location_1 = require("./_S3Location");
exports._OutputLocation = {
    type: "structure",
    required: [],
    members: {
        S3: {
            shape: _S3Location_1._S3Location
        }
    }
};
//# sourceMappingURL=_OutputLocation.js.map